export const HOME_PAGE_TEST_SCRIPT = ` (function () {
    function hasFunctionalConsent() {
      try {
        const cookie = document.cookie.split('; ').find(c => c.startsWith('OptanonConsent='));
        if (!cookie) return false;
        const groups = decodeURIComponent(cookie.split('=')[1]).split('&').find(g => g.startsWith('groups='));
        return groups && groups.includes('3:1'); // functional consent group
      } catch {
        return false;
      }
}

    // Only apply on homepage
    if (location.pathname === '/' && hasFunctionalConsent()) {
      const h = document.querySelector('.homepage h1');
      if (h) {
        h.style.visibility = 'hidden';
        h.dataset.wfPreHidden = 'true';
      }

      // Fallback: unhide after 3s if Optimize doesn't run
      setTimeout(() => {
        const h = document.querySelector('.homepage h1');
        if (h && h.dataset.wfPreHidden === 'true') {
          h.style.visibility = 'visible';
          delete h.dataset.wfPreHidden;
        }
      }, 3000);
    }
  })();`;
